import Vue from 'vue';
import VueRouter from 'vue-router';
import MainContent from '../components/Admin/MainContent.vue';
import InviteProspect from '../components/Admin/InviteProspect.vue';
import Register from '../views/RegistrationView.vue';
import Benefits from '../views/BenefitsView.vue';
import Status from '../components/Admin/ProspectStatus.vue';
import AccessDenied from '../components/Authentication/AccessDenied.vue';
import ProspectLogin from '../components/Authentication/ProspectLogin.vue';
import ForgotPassword from '../components/Authentication/ForgotPassword.vue';
import SetPasswordFromToken from '../components/Authentication/SetPasswordFromToken.vue';
import ValidateUser from '../components/Prospect/ValidateUser.vue';
import NotFound from '../components/NotFound.vue';
import SetPassword from '../components/Authentication/SetPassword.vue';
import ThankYou from '../components/Prospect/ThankYou.vue';
import AuditLogs from '../components/Admin/AuditLogs.vue';
import DocSign from '../components/DocSign.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'login',
    component: ProspectLogin,
  },
  {
    path: '/sign/:id',
    name: 'Sign',
    component: DocSign,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    beforeEnter: (to, from, next) => {
      if (from.name === 'login' || from.name === 'Status' || from.name === 'Benefits' || from.name === 'ThankYou') {
        next();
      } else {
        next({ name: 'login' });
      }
    },
  },
  {
    path: '/benefits',
    name: 'Benefits',
    component: Benefits,
    beforeEnter: (to, from, next) => {
      if (from.name === 'login' || from.name === 'Status' || from.name === 'Register' || from.name === 'ThankYou') {
        next();
      } else {
        next({ name: 'login' });
      }
    },
  },
  {
    path: '/verify/:guid',
    name: 'Verify',
    component: ValidateUser,
  },
  {
    path: '/setPassword',
    name: 'SetPassword',
    component: SetPassword,
  },
  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/forgotPassword/:tokenId',
    name: 'SetPasswordFromToken',
    component: SetPasswordFromToken,
  },
  {
    path: '/denied',
    name: 'Denied',
    component: AccessDenied,
  },
  {
    path: '/admin',
    name: 'Admin',
    component: MainContent,
  },
  {
    path: '/invite',
    name: 'Invite',
    component: InviteProspect,
  },
  {
    path: '/status',
    name: 'Status',
    component: Status,
  },
  {
    path: '/logs',
    name: 'AuditLogs',
    component: AuditLogs,
  },
  {
    path: '/thanks',
    name: 'ThankYou',
    component: ThankYou,
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
